import React, { Fragment, useContext, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import ReCAPTCHA from "react-google-recaptcha";
import usePageTitle from "../../hooks/usePageTitle";
import { env } from "../../env";

const ResetPasswordLink = (props) => {
  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);
  const configContext = useContext(ConfigContext);
  const { getConfigValueByCode } = configContext;
  const { setAlert, clearAlerts } = alertContext;
  const { reset_token, requestPasswordResetLink } = authContext;

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle: "Resend Reset Password Link",
  });

  const resendLink = async (e) => {
    e.preventDefault();
    //Get user details from Local Storage
    let userDetails = localStorage.getItem("user");
    userDetails = JSON.parse(userDetails);
    console.log("User Details", userDetails);
    /* To-DO : Call resentLink API */
    console.log("Resend the link");
    console.log("Resend the link", reset_token);
    const res = await requestPasswordResetLink(userDetails);
    if (res.status === "SUCCESS") {
      clearAlerts();
      const msg = getConfigValueByCode("patronConfig", "RESPONSE_MSG", 472);
      setAlert(msg, "info");
    } else if (res.msgCode) {
      const msg = getConfigValueByCode(
        "generalConfig",
        "RESPONSE_MSG",
        res.msgCode
      );
      clearAlerts();
      setAlert(msg, "danger");
    }
  };

  const [captcha, setCaptcha] = useState(false);

  const onCaptcha = (value) => {
    console.log(value);
    if (value) {
      setCaptcha(true);
    }
  };

  useEffect(() => {
    clearAlerts();
    //eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <div
        className="publicView"
        role="main"
        ref={props.mainContentRef}
        tabIndex="-1"
      >
        <h1 className="publicView__pageTitle">RESET ACCOUNT PASSWORD</h1>

        <div className="publicView__subPageTitle">
          Check Email for Reset Link
        </div>

        <div className="publicView__subPageTitleInfo">
          The link has been sent to your email address. Please check your inbox
          and click the reset link provided.
        </div>

        <div className="publicView__subPageTitleNotice">
          The Reset Link is valid for 60 minutes
        </div>

        <ReCAPTCHA
          className="publicView__formGroup__google-captcha"
          aria-label="google captcha"
          sitekey={env.REACT_APP_HMW_GGL_RECAPTCHA_KEY}
          onChange={onCaptcha}
        />

        <div className="publicView__subPageTitleNote">
          Didn't receive an email? Click here to
          <button
            name="resendLink"
            className="inlineActionButton"
            onClick={resendLink}
            disabled={!captcha}
          >
            {" "}
            Resend the link
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(ResetPasswordLink);
